//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'collectionDummy',
  props: ['type', 'ratio', 'count', 'minimal'],
}
